// @archigraph r8DljQiU

const TOKEN_KEYS = {
  accessToken: 'archigraph_access_token',
  idToken: 'archigraph_id_token',
  refreshToken: 'archigraph_refresh_token',
  expiresAt: 'archigraph_token_expires_at',
  rememberMe: 'archigraph_remember_me',
} as const;

export interface StoredTokens {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresAt: number;
}

function getStorage(): Storage {
  const rememberMe = localStorage.getItem(TOKEN_KEYS.rememberMe);
  return rememberMe === 'true' ? localStorage : sessionStorage;
}

export function saveTokens(tokens: StoredTokens, rememberMe: boolean): void {
  localStorage.setItem(TOKEN_KEYS.rememberMe, String(rememberMe));

  const storage = rememberMe ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEYS.accessToken, tokens.accessToken);
  storage.setItem(TOKEN_KEYS.idToken, tokens.idToken);
  storage.setItem(TOKEN_KEYS.expiresAt, String(tokens.expiresAt));

  // Refresh token always stored in localStorage for silent refresh
  localStorage.setItem(TOKEN_KEYS.refreshToken, tokens.refreshToken);
}

export function loadTokens(): StoredTokens | null {
  const storage = getStorage();
  const accessToken = storage.getItem(TOKEN_KEYS.accessToken);
  const idToken = storage.getItem(TOKEN_KEYS.idToken);
  const refreshToken = localStorage.getItem(TOKEN_KEYS.refreshToken);
  const expiresAt = storage.getItem(TOKEN_KEYS.expiresAt);

  if (!accessToken || !idToken || !refreshToken || !expiresAt) {
    return null;
  }

  return {
    accessToken,
    idToken,
    refreshToken,
    expiresAt: parseInt(expiresAt, 10),
  };
}

export function clearTokens(): void {
  for (const key of Object.values(TOKEN_KEYS)) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
}

export function isTokenExpired(): boolean {
  const tokens = loadTokens();
  if (!tokens) return true;
  return Date.now() >= tokens.expiresAt;
}
